import './AliadaProfile.scss'
import AliadaProfile from './AliadaProfile'
import * as paths from 'utils/paths'
import { serviceTypes } from '@src/globals'

class ReplacementAliadaProfile extends AliadaProfile {
  constructor (props) {
    super(props)
    this.reserveAliada = this.reserveAliada.bind(this)
  }

  reserveAliada () {
    const {
      bookingId,
      bookingTypeId,
      aliadaId,
      push,
      params: {
        userId
      }
    } = this.props

    const queryobject = { replacement_aliada_id: aliadaId }
    const pathFunction = bookingTypeId === serviceTypes.ONE_TIME.id ? paths.serviceChangeAliadaConfirm : paths.recurrenceChangeAliadaConfirm
    const changeAliadaUrl = pathFunction(userId, bookingId, queryobject)
    push(changeAliadaUrl)
  }
}

export default ReplacementAliadaProfile



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/AliadaProfile/ReplacementAliadaProfile.js